import { Stack } from "@mui/material";
import React from "react";
import TitleSection from "../Components/TitleSection";
import { LinkAndCancelButton, STEPS } from "../utils";
import Container from "../Components/Container";
import EventSummary from "../Components/EventSummary";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { useRescheduling } from "../ReschedulingProvider";

export default function MakeupDay() {
  const { setStep, setNewAppointmentTime, clientMakeupDays } = useRescheduling();
  return (
    <Container showGoHome>
      <TitleSection
        title="Need to change your therapy session?"
        subtitle="Use the make-up day you and your BCBA set up for days you can’t make therapy."
      />
      <Stack gap={7}>
        <EventSummary
          HighligthIcon={ArrowsClockwise}
          highlightText="Make-up Day"
          eventDate={clientMakeupDays[0]}
          onUpdate={() => {
            setNewAppointmentTime(clientMakeupDays[0]);
            setStep(STEPS.review);
          }}
        />
        <LinkAndCancelButton
          LinkLabel="View more reschedule times"
          onClickLink={() => setStep(STEPS.recommendations)}
          onCancel={() => setStep(STEPS.cancellationReview)}
        />
      </Stack>
    </Container>
  );
}
